import { PersonListItemType } from '@api';
import {
  faChevronDown,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Text, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type FirstnameCellProps = {
  record: PersonListItemType;
  handleToggleExpand: (_record: PersonListItemType) => void;
  isExpanded: boolean;
};

export const FirstnameCell: React.FC<FirstnameCellProps> = ({
  record,
  handleToggleExpand,
  isExpanded,
}) => {
  const { t } = useTranslation('persons');

  const expandedIcon = isExpanded ? faChevronDown : faChevronRight;

  const expandRow = (
    e: React.MouseEvent<HTMLButtonElement>,
    personListItem: PersonListItemType
  ) => {
    e.stopPropagation();
    handleToggleExpand(personListItem);
  };

  return (
    <Group>
      <UnstyledButton
        onClick={(e) => expandRow(e, record)}
        aria-label={t('TABLE.TOGGLE_EXPAND')}
      >
        <FontAwesomeIcon icon={expandedIcon} size="xs" width={15} />
      </UnstyledButton>
      <Text>{record.firstname}</Text>
    </Group>
  );
};
